<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body" id="divBody">


        <div>
          <div class="row col ">

            <div class="col-sm-3">
              <label>Journal</label>
              <select id="ddlJournal" class="form-control" onchange="$('#btnGetFieldList').trigger('click');">
                <option selected value="0">Select</option>
                <option *ngFor="let item of journalList" value={{item.ID}}>
                  {{item.Acronym}}
                </option>
              </select>
            </div>

            <div class="col-sm-3">
              <label>Table Name</label>
              <select id="ddlTableName" class="form-control" onchange="$('#btnGetFieldList').trigger('click');">
                <option selected value="All">All</option>
                <option *ngFor="let item of tableList" value={{item.TableName}}>
                  {{item.TableName}}
                </option>
              </select>
            </div>
            <div class="col-sm-3">

              <button type="button" class="btn btn-outline-info waves-effect waves-light clsMargin" id="btnGetFieldList" (click)="getFieldList()">Search</button>&nbsp;&nbsp;&nbsp;

              <button type="button" class="btn btn-outline-danger waves-effect waves-light clsMargin" (click)="Reset()">Reset</button>&nbsp;&nbsp;&nbsp;
            </div>
            <div class="col-sm-3" style="text-align:right;">

              <button type="button" class="btn btn-outline-success waves-effect waves-light clsMargin" (click)="updateFieldDetails()">Update</button>&nbsp;&nbsp;&nbsp;
              <button type="button" class="btn btn-outline-info waves-effect waves-light clsMargin" (click)="addNewRow()">Add New Row</button>
            </div>

          </div>
          <br />

          <div class="row">
            <div class="col-md-12">
              <div class="row tblDataList col-md-12 fixTableHead">
                <table class="table" id="tblDataList">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Table Name</th>
                      <th>Table Field</th>
                      <th>Label Name</th>
                      <th>Visible</th>
                      <th>Editable</th>
                      <th>Mandatory</th>
                      <th>Confirmation</th>
                      <th>Char Length</th>
                      <th>Class Col</th>
                      <th>Display Order</th>
                    </tr>
                  </thead>
                  <tbody class="tblDataListBody">
                    <tr *ngFor="let item of aFieldList" id="tr{{ item.Id }}">
                      <td>{{item.Id}}</td>
                      <td><input type='text' value="{{item.TableName}}" /></td>
                      <td><input type='text' value="{{item.TableField}}" /></td>
                      <td><input type='text' value="{{item.LabelName}}" /></td>
                      <td><input type='checkbox' name='IsVisible' [checked]="item.IsVisible" /></td>
                      <td><input type='checkbox' name='IsEditable' [checked]="item.IsEditable" /></td>
                      <td><input type='checkbox' name='IsMandatory' [checked]="item.IsMandatory" /></td>
                      <td><input type='checkbox' name='IsConfirmation' [checked]="item.IsConfirmation" /></td>
                      <td><input type='number' value="{{item.CharLength}}" style="width:70px" /></td>
                      <td><input type='text' value="{{item.ClassCol}}" style="width: 100px" /></td>
                      <td><input type='number' value="{{item.DisplayOrder}}" style="width: 70px" /></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
